
import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import AlertItem from "../../widgets/AlertItem";
import Prompt from '../../widgets/Prompt';
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import UserSearch from "../UserSearch";
import { EmployerAddUserForm } from "../employer/EmployerAddUserForm";
import LinkDialog from "../LinkDialog";
import FormDialog from "../FormDialog";

const headCells = [
    { id: 'FirstName', numeric: false, disablePadding: true, label: 'First Name' },
    { id: 'Surname', numeric: false, disablePadding: true, label: 'Surname' },
    { id: 'IDNo', numeric: false, disablePadding: true, label: 'ID No' },
    { id: 'TelephoneNumber', numeric: false, disablePadding: true, label: 'Telephone Number' },
    { id: 'CellphoneNumber', numeric: false, disablePadding: true, label: 'CellPhone Number' },
    { id: 'FaxNumber', numeric: false, disablePadding: true, label: 'Fax Number' },
    { id: 'Email', numeric: false, disablePadding: true, label: 'Email' }

];

const utils = new ViewUtils();
const toolbarRef = React.createRef();
const addFormRef = React.createRef();

class employerUsersSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            linkDialogOpen: false,
            formDialogOpen: false,
            selectedUser: null,
            propmtOpen: false,
            promptTitle: "Remove user from employer",
            promptContent: "Are you sure you want to remove this user from the employer?",
            unlinkMessage: "",
            unlinkMessageStyle: "",
            searchParameters: [{ Name: "EmployerID", Value: this.props.location.state.selection }]
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: "link", label: '', icon: 'LinkIcon', tooltip: 'Link existing user to employer' },
                        { id: 'add', label: '', icon: 'AddIcon', tooltip: 'Add new user to employer' },
                        { id: 'remove', label: '', icon: 'DeleteIcon', tooltip: 'Remove user from employer', disabled: utils.isNull(this.state.selectedUser) }
                    ]
                }
            ]
        };

    }

    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/employer',
                state: { selection: this.props.location.state.selection }
            });
        }
        else if ("add" === buttonId) {
            this.setState({ formDialogOpen: true })
        }
        else if ("link" === buttonId) {
            this.setState({ linkDialogOpen: true })
        }
        else if ("remove" === buttonId) {
            this.setState({ promptOpen: true })
        }
    }

    dialogActionHandler(isCancel, added) {
        if (added === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                formDialogOpen: false, selectedUser: null,
                linkDialogOpen: false
            });
        }
        else if (isCancel === true) {
            this.setState({
                formDialogOpen: false,
                linkDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedUser: selection[0].Id });
        }
        else {
            this.setState({ selectedUser: null });
        }
        toolbarRef.current.setButtonDisabled("remove", selection === null || selection.length === 0);
    }

    successfulUserRemoveCallback = (response) => {

        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({ selectedUser: null, removeMessage: response.Message, removeMessageStyle: response.MessageType.toLowerCase() });
            //Force a refresh
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
    }

    unsuccessfulUserRemoveCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({ removeMessage: response.Message, removeMessageStyle: response.MessageType.toLowerCase() })
        }
    }

    removeUser(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("remove", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedUser}&employerId=${this.props.location.state.selection}`;
        utils.invokeUrlDelete(fullUrl, this.successfulUserRemoveCallback, this.unsuccessfulUserRemoveCallback);
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {"Employer > Users" + (this.props.location.state !== null ? " > " + this.props.location.state.employerName + (this.props.location.state.employerSDLNo !== null ? " - " + this.props.location.state.employerSDLNo : "") : "> Add")}
                </p>
                <AlertItem message={this.state.unlinkMessage} alertStyle={this.state.unlinkMessageStyle} />

                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig} />

                    <EnhancedTable
                        headCells={headCells}
                        dataUrl={`api/sims/employeruser/GetEmployerUsers`}
                        height="50vh"
                        onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        searchParameters={this.state.searchParameters} paged={true} />
                </div>

                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    title={this.props.location.state.qualificationTitle}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                    dialogTitle={`Link users to employer: ${this.props.location.state.employerName}`}
                    linkName={"Users"} postUrl={"api/sims/employeruser/LinkEmployerUser"} usePost={true}
                    selectionId={this.props.location.state.selection}
                >

                    <UserSearch
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.selection} programmeType="Q"
                        mode="lookup"
                        dataUrl= "api/sims/employeruser/GetSearchLinkableUsers"
                    />
                </LinkDialog>

                <FormDialog
                    open={this.state.formDialogOpen}
                    dialogTitle={"Add employer User"}
                    viewRef={this}
                    formRef={addFormRef}
                    saveUrl={"api/sims/employeruser/InsertEmployerUser"}
                    usePost={true}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                >
                    <EmployerAddUserForm ref={addFormRef} />
                </FormDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => { this.removeUser("api/sims/employeruser/RemoveEmployerUser") }}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(employerUsersSearch)
);